(function ($, Drupal, drupalSettings) {
  'use strict';
  var eventTimeIso = '2019-09-15T19:00:00-05:00';

  Drupal.behaviors.kenBurnsHeroBlock = {

    liveRelease: function () {
      $('.pre-release').removeClass('show').addClass('hide');
      $('.post-release').removeClass('hide').addClass('show');
    },

    initializeCountdownClock: function () {
      // Show the timer. Hide the release.
      $('.pre-release').removeClass('hide').addClass('show');
      $('.post-release').removeClass('show').addClass('hide');

      // Countdown timer.
      // Event time in ISO format - 08-24-2018 12:00 CST
      var eventTime = dayjs(eventTimeIso); // eslint-disable-line no-undef
      var currentTime = dayjs(); // eslint-disable-line no-undef
      var seconds = eventTime.diff(currentTime, 'seconds');

      // Find all jQuery elements.
      var $countdowntimer = $('.block-ken-burns-hero-block__countdown-timer');
      var $d = $countdowntimer.find('.block-ken-burns-hero-block__countdown-days-number');
      var $h = $countdowntimer.find('.block-ken-burns-hero-block__countdown-hours-number');
      var $m = $countdowntimer.find('.block-ken-burns-hero-block__countdown-minutes-number');
      var $s = $countdowntimer.find('.block-ken-burns-hero-block__countdown-seconds-number');

      var countdownInterval = setInterval(function () {
        // Grab current time every second.
        currentTime = dayjs(); // eslint-disable-line no-undef

        // Calculate all the seconds between now and until event time.
        seconds = eventTime.diff(currentTime, 'seconds');

        // See if we're in the negatives.
        // Live release!
        if (seconds <= 0) {
          clearInterval(countdownInterval);
          Drupal.behaviors.kenBurnsHeroBlock.liveRelease();
        }

        // Do the seconds to days, hours and minutes conversion.
        var days = Math.floor(seconds / (3600 * 24));
        seconds -= days * 3600 * 24;
        var hours = Math.floor(seconds / 3600);
        seconds -= hours * 3600;
        var minutes = Math.floor(seconds / 60);
        seconds -= minutes * 60;

        // Format hours, minutes and seconds to always have leading zero.
        days = $.trim(days).length === 1 ? '0' + days : days;
        hours = $.trim(hours).length === 1 ? '0' + hours : hours;
        minutes = $.trim(minutes).length === 1 ? '0' + minutes : minutes;
        seconds = $.trim(seconds).length === 1 ? '0' + seconds : seconds;

        // Show how many hours, minutes and seconds are left.
        // Pad zero for double-digits always.
        $d.text(days);
        $h.text(hours);
        $m.text(minutes);
        $s.text(seconds);
      }, 1000);
    },

    attach: function (context, settings) {
      $('.block-ken-burns-hero-block').each(function () {
      });
    }
  };
})(jQuery, Drupal, drupalSettings);
